import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import { Fab } from '@marageti/z4-lib';
import { useTravelerProfileSuggestionsStore } from '../../store';

// Reserves vertical space at the bottom of the page so the fixed FAB doesn't
// overlap the last bit of profile content (e.g. the +Add Countries button).
// Sized to clear the bar (`py: 2` + medium button + 1px border ≈ 70px) with
// a small visual gap.
const FAB_SPACER_HEIGHT = 80;

const SuggestionsFab = () => {
  const ctx = useTravelerProfileSuggestionsStore();
  if (!ctx) return null;

  const {
    fabMode,
    isSaving,
    isLoadingSuggestions,
    applyAll,
    requestDismissAll,
    save,
  } = ctx;

  if (fabMode === 'hidden') return null;

  const disabled = isSaving || isLoadingSuggestions;

  return (
    <>
      <Box aria-hidden sx={{ height: FAB_SPACER_HEIGHT }} />
      <Fab>
        <Stack direction="row" spacing={2}>
          {fabMode === 'save' ? (
            <Button
              variant="contained"
              onClick={save}
              disabled={disabled}
            >
              {isSaving ? 'Saving...' : 'Save'}
            </Button>
          ) : (
            <>
              <Button
                variant="contained"
                onClick={applyAll}
                disabled={disabled}
              >
                Apply All
              </Button>
              <Button
                variant="outlined"
                onClick={requestDismissAll}
                disabled={disabled}
              >
                Dismiss All
              </Button>
            </>
          )}
        </Stack>
      </Fab>
    </>
  );
};

export default SuggestionsFab;
